export default __webpack_public_path__ + "static/media/select-radio-active.a1d2b05b.svg";